import { TemplateConfig } from '../types';

export const exPartnerStalkingSpreadConfig: TemplateConfig = {
  id: 'ex-partner-stalking-spread',
  name: '视奸前任牌阵',
  description: '分析前任目前的状态以及对你的看法',
  cardCount: 5,

  fieldDefaults: {
    title: '视奸前任牌阵',
    customerQuestion: '分析前任目前的状态以及对你的看法。',
    cardPlaceholders: [
      '请输入第 2 列第 1 张牌',
      '请输入第 3 列第 1 张牌',
      '请输入第 2 列第 2 张牌',
      '请输入第 3 列第 2 张牌',
      '请输入第 1 列第 1 张牌'
    ],
    cardInfos: [
      '对方目前的感情状况',
      '对方目前的财务状况',
      '对方目前对你的看法',
      '离开之后对方有没有想起过你',
      '对方后悔和你分手吗'
    ]
  },

  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],

  generateOptions: {
    normal: true,
    thinking: true
  },

  ui: {
    color: '#1890ff',
    backgroundColor: '#e6f7ff',
    icon: '👀'
  }
};
